import React from 'react';
import Card from 'react-bootstrap/Card';
import { Community } from 'services/graphqltypes';
import { Link } from 'react-router-dom';
import MultilingualText from 'components/Multilingual/MultilingualText';
import { parseNominatimLocationName } from 'helpers/utils-typescript';

type CommunityCardProp = {
  community: Community;
};

function CommunityCard({ community }: CommunityCardProp): React.ReactElement {

  const locationName = community.locationName;
  const locationAddress = community.locationAddress;
  const locationCoordinates = community.locationCoordinates;
  const parsedLocationName = parseNominatimLocationName(locationName, locationAddress, locationCoordinates);

  return (
    <>
      <Link key={community.id} to={`/community/${community.slug}`}>
        <Card className="d-flex flex-row mb-3">
          <div className="position-relative">
            <img
              loading='lazy'
              alt="Community Logo"
              src={community.avatarUrl ? community.avatarUrl : '/logo512.png'}
              className="list-thumbnail responsive border-0 card-img-left"
            />
          </div>
          <div className="d-flex flex-grow-1 min-width-zero">
            <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
              <div className="list-item-heading w-30 w-sm-100">
                <MultilingualText value={community.name} />
              </div>
              <div className="w-40 w-sm-100 text-muted text-small font-weight-bold truncate mt-1 mt-md-0">
                <MultilingualText value={community.aboutOneliner} />
              </div>
              <div className="w-25 w-sm-100 truncate text-muted text-small font-weight-bold mt-1 mt-md-0">
                {(parsedLocationName.includes('undefined'))
                  ? <MultilingualText value={community.location?.name} /> // this is the old style location -> fallback
                  : parsedLocationName
                }
              </div>
            </div>
          </div>
        </Card>
      </Link>
    </>
  );
}

export default CommunityCard;
